/**
 * Text Uniquement Manager - Moon Moon Agency
 * Toggle "Voir plus" / "Voir moins" sur la liste de blocks (MM-Text-Uniquement)
 */

/*********************************************************************************************
 * 🔧 TEXT UNIQUEMENT MANAGER
 */
const TextUniquementManager = {
	config: {
		selectors: {
			wrapper: '[data-mm-text-uniquement-readmore]',
			trigger: '[data-mm-text-uniquement-readmore-trigger]',
			label: '[data-mm-text-uniquement-readmore-label]',
			list: '.mm-text-uniquement__list',
		},
		classes: {
			expanded: 'mm-text-uniquement__list-wrapper--expanded',
			fits: 'mm-text-uniquement__list-wrapper--fits',
		},
		collapsedHeightProperty: '--mm-text-uniquement-collapsed-height',
		minHiddenHeight: 100,
	},

	init() {
		const wrappers = window.getElements(this.config.selectors.wrapper);
		if (!wrappers.length) return;

		this._observeLists(wrappers);
		this._bindEvents();
		window.log('info', '🔧 [TEXT_UNIQUEMENT]', 'Initialized', { count: wrappers.length });
	},

	_observeLists(wrappers) {
		const observer = new ResizeObserver((entries) => {
			entries.forEach(({ target }) => this._updateFit(target));
		});

		wrappers.forEach((wrapper) => {
			const list = wrapper.querySelector(this.config.selectors.list);
			if (list) observer.observe(list);
		});
	},

	_updateFit(list) {
		const wrapper = list.closest(this.config.selectors.wrapper);
		if (wrapper.classList.contains(this.config.classes.expanded)) return;

		const collapsedHeight = parseFloat(getComputedStyle(list).getPropertyValue(this.config.collapsedHeightProperty));
		const fits = list.scrollHeight - collapsedHeight <= this.config.minHiddenHeight;
		if (fits === wrapper.classList.contains(this.config.classes.fits)) return;

		wrapper.classList.toggle(this.config.classes.fits, fits);
		window.emit('global:content-resized');
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest(this.config.selectors.trigger);
			if (!trigger) return;
			this.toggle(trigger);
		});
	},

	toggle(trigger) {
		const wrapper = trigger.closest(this.config.selectors.wrapper);
		const list = wrapper && wrapper.querySelector(this.config.selectors.list);
		if (!wrapper || !list) return;

		const isExpanded = !wrapper.classList.contains(this.config.classes.expanded);

		// Repart toujours de la hauteur réelle du contenu (scrollHeight) : c'est le point
		// de départ commun pour animer aussi bien l'ouverture que le repli vers le CSS.
		list.style.maxHeight = `${list.scrollHeight}px`;
		wrapper.classList.toggle(this.config.classes.expanded, isExpanded);

		if (!isExpanded) {
			requestAnimationFrame(() => {
				list.style.maxHeight = '';
			});
		}

		trigger.setAttribute('aria-expanded', String(isExpanded));

		const label = trigger.querySelector(this.config.selectors.label);
		if (label) {
			label.textContent = isExpanded ? trigger.dataset.labelLess : trigger.dataset.labelMore;
		}

		// La hauteur du document change sans ajout/retrait de noeuds DOM : Lenis
		// (smooth scroll) ne le détecte pas tout seul, on force son recalcul une
		// fois la transition CSS terminée (sinon la limite de scroll reste figée
		// sur l'ancienne hauteur, "bloquant" le scroll avant le vrai bas de page).
		// Un 2e appel avec un léger délai sert de filet : au moment précis du
		// `transitionend`, le layout n'est pas toujours encore totalement stabilisé.
		list.addEventListener('transitionend', () => {
			window.emit('global:content-resized');
			setTimeout(() => window.emit('global:content-resized'), 150);
		}, { once: true });

		window.emit('global:text-uniquement-readmore-toggled', { expanded: isExpanded });
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => TextUniquementManager.init());
} else {
	TextUniquementManager.init();
}
